import React from 'react';
import { responseInterface } from 'swr';
import { Redirect } from 'react-router-dom';

import MeetingDetails from '../../../app/shared/MeetingDetails/MeetingDetails';
import EventDetails from '../../../app/shared/EventDetails';
import { HTTP_STATUS, ResponseError } from '../../../config/api';
import { useMeetingPrivateDetails } from '../../../hooks/api/protected/use-meeting-private-details';
import { PrivateMeetingDetailsResponseType } from '../../../lib/api';
import { EventSettingsContextType, useEventSettings } from '../../../lib/context-providers/event-settings-context/event-settings-context';
import useConnectMeetingDisabled from '../../../hooks/use-connect-meeting-disabled';
import useDefaultRoutePage from '../../../hooks/use-default-route-page';
import { SingleMeetingPageType } from '../../../lib/api/custom-page.types';
import MeetingNotAvailableMessage from '../../shared/MeetingDetails/MeetingNotAvailableMessage';
import '../MeetingWrapper/MeetingWrapper.scss';

const SingleMeetingPageWrapper: React.FC<SingleMeetingPageType> = (props: SingleMeetingPageType): JSX.Element | null => {
  const eventSettings = useEventSettings() as EventSettingsContextType;
  const landingPage = useDefaultRoutePage();
  const { data: meetingDetails, error } = useMeetingPrivateDetails(eventSettings.eventId.toString(), props.meetingId.toString()) as responseInterface<PrivateMeetingDetailsResponseType, ResponseError>;
  const isConnectBtnDisabled = useConnectMeetingDisabled(eventSettings, meetingDetails?.startDateTime);

  if (error && (error.status === HTTP_STATUS.FORBIDDEN || error.status === HTTP_STATUS.NOT_FOUND)) {
    return <Redirect to={landingPage} />;
  }

  if (meetingDetails && meetingDetails.isAvailable === false) {
    return (
      <MeetingNotAvailableMessage
        showTopNavBtns={false}
        agendaLabel={eventSettings.agendaLabel}
      />
    );
  }

  if (eventSettings && meetingDetails) {
    return (
      <>
        <EventDetails details={eventSettings} />
        <MeetingDetails
          meetingDetails={meetingDetails}
          showTopNavBtns={false}
          timeZone={eventSettings.timeZone}
          agendaLabel={eventSettings.agendaLabel}
          isConnectBtnDisabled={isConnectBtnDisabled}
          eventName={eventSettings.name}
          eventId={eventSettings.eventId.toString()}
          showAddToCalendarBtn={true}
          eventCustomTitle={eventSettings.eventTitleForPassport}
          singleMeetingPath={props.path}
          meetingLinksLabel={eventSettings.meetingLinksLabel}
          calendarInvite={eventSettings.calendarInvite}
        />
      </>
    );
  }
  return null;
};

export { SingleMeetingPageWrapper };
